export type Type = {
	search: {
		sources: string;
		products: string;
	};
	showReceipt: boolean;
	editMode: boolean;
};

export function create(editMode?: boolean): Type {
	return {
		search: {
			sources: '',
			products: '',
		},
		showReceipt: false,
		editMode: editMode ?? false,
	};
}

export function toggleShowReceipt(obj: Type): Type {
	return { ...obj, showReceipt: !obj.showReceipt };
}

export function toggleEditMode(obj: Type): Type {
	return { ...obj, editMode: !obj.editMode };
}

export function setSearchSources(obj: Type, input: string) {
	return { ...obj, search: { ...obj.search, sources: input } };
}

export function setSearchProducts(obj: Type, input: string) {
	return { ...obj, search: { ...obj.search, products: input } };
}
